export const getCities = (state) => state.cities
export const getCity = (state) => (id) => { return state.cities.find((city) => { return city.id === id }) }
